<template>
	<div class="setmode" :style="{ height: `${windowHeight}px` }">
		<el-row>
			<el-col :span="7" style="color:transparent">1</el-col>
			<el-col :span="2" class="collabel"><span>模板名称</span></el-col>
			<el-col :span="4" >
				<el-select
					v-model="t_name"
					size="mini"
					@change="handleSelect"
				>
					<el-option v-for="item in modelist" :key="item.t_id" :label="item.t_name" :value="item.t_id"></el-option>
				</el-select>
			</el-col>
			<el-col :span="4" class="submitBtn">
				<el-button type="success" size="mini" @click="GetPrintTemplate">打开</el-button>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
	},
	data() {
		return {
			windowHeight: window.innerHeight - 120,
			t_name:'',
			t_id:'',
			modelist:[],
			template:'',//模板内容
			divclass:'setmode'
		};
	},
	mounted() {
		this.GetPrintMode();
	},
	methods: {
		GetPrintMode(){
			var that=this;
			this.$apipost.get.GetPrintMode({}).then(res => {
				that.modelist=res.list;
			});
		},
		GetPrintTemplate(){
			var that=this;
			this.$tool.loading('正在打开模板', this.divclass);
			this.$apipost.get.GetPrintTemp({t_id:this.t_id}).then(res => {
				this.$tool.loadingclose();
				if(res.indexOf('%')>-1)
					eval(res);
				else
					eval(decodeURIComponent(res));
				if (LODOP.CVERSION) {
					CLODOP.On_Return = function (TaskID, Value) {
						that.$confirm('确认保存当前设置?', '提示', {
							cancelButtonText: '否',
							confirmButtonText: '是',
							type: 'success',
							showClose: false,
							closeOnClickModal: false
						})
							.then(res => {
								if (res == 'confirm') {
									that.SavePrintTemplate(Value);
								}
							}).catch(() => {});
					};
				}
			});
		},
		SavePrintTemplate(values){
			var template='',image='';
			 var re = values.split("LODOP");
			if (re.length > 0) {
				for (var i = 0; i < re.length; i++) {
					if (re[i] != "") {
						if (re[i].substring(1, re[i].indexOf("(")) == "ADD_PRINT_IMAGE") {
							image += "LODOP" + re[i];
						}
						else { template += "LODOP" + re[i]; }
					}
				}
			}
			template=template.replace(/\+/g, '%2B');
			image=image.replace(/\+/g, '%2B');
			this.$tool.loading('正在保存', this.divclass);
			this.$apipost.post.SavePrintTemplate({t_id:this.t_id,template:template,image:image}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1')
					this.$tool.message('保存成功',1);
				else
					this.$tool.message('保存失败',0);
			});
		},
		handleSelect(item) {
			this.t_id=item;
		}
	}
}
</script>
<style>
.setmode{
	text-align:center;
	padding-top:10%;
}
.footerhandler{
			margin-top:20px;
		}
</style>
